module.exports = "/img/logo-fit.png?d41d561c550075a7d6827965e272d3f1";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/logo-fit.png
// module id = QR5C
// module chunks = 72